import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW6000Model } from '../kymw6000.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { FeatureListInfo } from '../vo/feature_list_info.model';

// レスポンス構造
type GetFeatureThemaListResponse = {
  FeatureCode: string;
  FeatureName: string;
}[];

/**
 * 特集情報一覧取得サービス
 * @export GetFeatureThemaListService
 * @class GetFeatureThemaListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureThemaListService extends PlessJsonResponderSub<GetFeatureThemaListResponse> {
  model: KYMW6000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureThemaListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureThemaListService
   */
  execute(model: KYMW6000Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('KYMW60getFeatureThemaList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureThemaListService
   */
  success(data: GetFeatureThemaListResponse) {
    const featureList = [];
    data.forEach(item => {
      if (item.FeatureCode != '') {
        const addList = new FeatureListInfo(item.FeatureCode,item.FeatureName);
        featureList.push(addList);
      }
    })
    this.model.FeatureList = (featureList)
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
